'use strict';
(function() {
  angular
    .module('cfn')
    .factory('cropOverviewControllerResolver', cropOverviewControllerResolver);

  cropOverviewControllerResolver.$inject = ['$http'];

  function cropOverviewControllerResolver($http) {
    return function() {
      // Load list of relevant harvest years
      var req = $http.get('/365FarmNet/rest/analyse/cropoverview/harvestyears');
      return req.then(function(response) {
        return response.data;
      });
    };
  }
})();
